var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.tags),function(tag){return _c('el-tag',{key:tag.id,class:_vm.$style.tag},[_vm._v(" "+_vm._s(tag.name)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }